import { Resume } from '@sr/types';
import React from 'react';
import { Box, Flex, Radio, Text } from '../../ui';
import API from '../../utils/api';

const VisibilityPicker = ({ resume }: { resume: Resume }) => {
  const { visibility } = resume;
  return (
    <Box pt={5}>
      <Text variant="listHeading" pb={3}>
        Web Resume Permissions
      </Text>
      <Flex
        id="gi-share-visibility-public"
        data-testid="visibility-public"
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          API.resume.updateVisibility({ resume, visibility: 'public' });
          API.events.logEvent({
            userId: resume.owner,
            eventName: 'Resume Changed Visibility',
            properties: {
              Visibility: 'Public',
            },
          });
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Radio checked={visibility === 'public'} />
        </Box>
        <Box pl={2} pb={5}>
          <Text variant="base">Public</Text>
          <Text variant="caption" color="black50">
            Your web resume will be publicly available and may be included in
            search results.
          </Text>
        </Box>
      </Flex>
      <Flex
        id="gi-share-visibility-secret"
        data-testid="visibility-secret"
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          API.resume.updateVisibility({ resume, visibility: 'secret' });
          API.events.logEvent({
            userId: resume.owner,
            eventName: 'Resume Changed Visibility',
            properties: {
              Visibility: 'Secret',
            },
          });
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Radio checked={visibility === 'secret'} />
        </Box>
        <Box pl={2} pb={5}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Text variant="base" pr={2}>
              Secret
            </Text>
          </Box>
          <Text variant="caption" color="black50">
            Your web resume will be visible to anyone with the link. We'll tell
            Google not to include your resume in search results.
          </Text>
        </Box>
      </Flex>
      <Flex
        id="gi-share-visibility-secret"
        sx={{ cursor: 'pointer' }}
        data-testid="visibility-private"
        onClick={() => {
          API.resume.updateVisibility({ resume, visibility: 'private' });
          API.events.logEvent({
            userId: resume.owner,
            eventName: 'Resume Changed Visibility',
            properties: {
              Visibility: 'Private',
            },
          });
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Radio checked={visibility === 'private'} />
        </Box>
        <Box pl={2} pb={5}>
          <Text variant="base">Private</Text>
          <Text variant="caption" color="black50">
            Your web resume won't be viewable by any person or search engine.
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default VisibilityPicker;
